import { colors } from "../config";

export const handleOutlookLogin = (loginType, instance, loginRequest) => {
  if (loginType === "popup") {
    instance.loginPopup(loginRequest).catch((e) => {
      console.log(e);
    });
  } else if (loginType === "redirect") {
    instance.loginRedirect(loginRequest).catch((e) => {
      console.log(e);
    });
  }
};

// export function composeEventForOutlook({
//   type,
//   title,
//   date,
//   duration,
//   timezone,
//   clientName,
//   categoryName,
//   meetingPlace,
//   selectedColor,
//   attendees,
//   absenceStatus,
//   absenceType
// }) {
//   let startDate = date.clone();
//   let endDate = date.clone();
//   const minutesToAdd = duration;
//   const eventDetails = {};

//   const limitedDurationEvents = [
//     "task",
//     "meeting",
//     "management",
//     "balancePresentation",
//   ];
//   const allDayEvents = ["balanceEcheance", "intermediateSituationBalance"];

//   if (limitedDurationEvents.includes(type)) {
//     let composedTitle = "";
//     endDate.add(minutesToAdd, "minutes");

//     if (type === "task") {
//       composedTitle = `[Tâche] ${clientName} - ${categoryName}`;
//     } else if (type === "meeting") {
//       composedTitle = `Rendez-vous avec ${clientName}`;
//     } else if (type === "management") {
//       composedTitle = `[Gestion] ${title}`;
//     } else if (type === "balancePresentation") {
//       composedTitle = `[Présentation Bilan] ${clientName}`;
//     }

//     eventDetails.subject = composedTitle;

//     if (
//       (type === "meeting" ||
//         type === "balancePresentation") &&
//         meetingPlace === "remote"
//     ) {
//       eventDetails.responseRequested = true;
//       eventDetails.allowNewTimeProposals = true;
//       eventDetails.isOnlineMeeting = true;
//       eventDetails.onlineMeetingProvider = "teamsForBusiness";
//     }
//   } else if (allDayEvents.includes(type)) {
//     let title = "";

//     startDate.hour(0);
//     startDate.minute(0);
//     startDate.second(0);
//     startDate.millisecond(0);

//     endDate.add(1, "day");
//     endDate.hour(0);
//     endDate.minute(0);
//     endDate.second(0);
//     endDate.millisecond(0);

//     if (type === "balanceEcheance") {
//       title = `[Échéance Bilan] ${clientName} - ${categoryName}`;
//     } else if (type === "intermediateSituationBalance") {
//       title = `[Situation Intermédiaire] ${clientName} - ${categoryName}`;
//     }

//     eventDetails.subject = title;
//     eventDetails.isReminderOn = true;
//     eventDetails.isAllDay = true;
//   } else if (type === "absence") {
//     eventDetails.subject = title;
//     if (!title) {
//       if (absenceType === 'absence') {
//         eventDetails.subject = 'Vacances annuelles';
//       }
//     }
//     startDate.hour(0);
//     startDate.minute(0);
//     startDate.second(0);
//     startDate.millisecond(0);

//     if (absenceType === 'partial') {
//       startDate.hour(8);
//       startDate.minute(0);
//       startDate.second(0);
//       startDate.millisecond(0);
//       endDate = startDate.clone();
//       endDate.add(duration, "minutes");
//     } else {
//       endDate.add(duration, "minutes");
//       endDate.hour(0);
//       endDate.minute(0);
//       endDate.second(0);
//       endDate.millisecond(0);
//     }

//     if (absenceStatus === 'PENDING') {
//       eventDetails.showAs = 'free';
//     } else if (absenceStatus === 'APPROVED') {
//       eventDetails.showAs = 'busy';
//     } else if (absenceStatus === 'REJECTED') {
//       eventDetails.showAs = 'tentative';
//     }
//   }

//   eventDetails.start = {
//     dateTime: startDate.format("Y-MM-DDTHH:mm:ss"),
//     timeZone: timezone,
//   };
//   eventDetails.end = {
//     dateTime: endDate.format("Y-MM-DDTHH:mm:ss"),
//     timeZone: timezone
//   };
//   eventDetails.location = {
//     displayName: "Microsoft Teams",
//   };

//   let color = selectedColor;
//   if (!color) {
//     color = colors[0].id;
//   }

//   eventDetails.categories = [color];
//   eventDetails.attendees = attendees;

//   if(type !== 'absence') {
//     if (type === 'balanceEcheance') {
//       eventDetails.showAs = 'free';
//     } else {
//       eventDetails.showAs = 'busy';
//     }
//   }

//   return eventDetails;
// }


export function composeEventForOutlook({
  type,
  title,
  date,
  duration,
  timezone,
  clientName,
  categoryName,
  meetingPlace,
  selectedColor,
  attendees,
  absenceStatus,
  absenceType
}) {
  switch (type) {
    case "task":
      return composeTaskEventForOutlook({
        title,
        date,
        duration,
        timezone,
        clientName,
        categoryName,
        selectedColor,
        attendees,
      });
    case "meeting":
      return composeMeetingEventForOutlook({
        title,
        date,
        duration,
        timezone,
        clientName,
        categoryName,
        meetingPlace,
        selectedColor,
        attendees,
      });
    case "management":
      return composeManagementEventForOutlook({
        title,
        date,
        duration,
        timezone,
        selectedColor,
        attendees,
      });
    case "balancePresentation":
      return composeBalancePresentationEventForOutlook({
        title,
        date,
        duration,
        timezone,
        clientName,
        selectedColor,
        attendees,
      });
    case "balanceEcheance":
      return composeBalanceEcheanceEventForOutlook({
        title,
        date,
        timezone,
        clientName,
        categoryName,
        selectedColor,
        attendees,
      });
    case "intermediateSituationBalance":
      return composeIntermediateSituationBalanceEventForOutlook({
        title,
        date,
        timezone,
        clientName,
        categoryName,
        selectedColor,
        attendees,
      });
    case "absence":
      return composeAbsenceEventForOutlook({
        title,
        date,
        duration,
        timezone,
        absenceStatus,
        absenceType,
        selectedColor,
        attendees,
      });
    case "newClientMeeting":
      return composeNewClientMeetingEventForOutlook({
        title,
        date,
        duration,
        timezone,
        clientName,
        selectedColor,
        attendees,
      });
    default:
      return null;
  }
}

function composeTaskEventForOutlook({
  title,
  date,
  duration,
  timezone,
  clientName,
  categoryName,
  selectedColor,
  attendees,
}) {
  let startDate = date.clone();
  let endDate = date.clone();
  const minutesToAdd = duration;
  const eventDetails = {};

  let composedTitle = "";
  endDate.add(minutesToAdd, "minutes");

  composedTitle = `[Tâche] ${clientName} - ${categoryName}`;

  if (title) {
    composedTitle = `${title}`;
  }

  eventDetails.subject = composedTitle;

  eventDetails.start = {
    dateTime: startDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone,
  };
  eventDetails.end = {
    dateTime: endDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone
  };
  eventDetails.location = {
    displayName: "Microsoft Teams",
  };

  let color = selectedColor;
  if (!color) {
    color = colors[0].id;
  }

  eventDetails.categories = [color];
  eventDetails.attendees = attendees;

  return eventDetails;
}

function composeMeetingEventForOutlook({
  title,
  date,
  duration,
  timezone,
  clientName,
  categoryName,
  meetingPlace,
  selectedColor,
  attendees,
}) {
  let startDate = date.clone();
  let endDate = date.clone();
  const minutesToAdd = duration;
  const eventDetails = {};

  let composedTitle = "";
  endDate.add(minutesToAdd, "minutes");

  composedTitle = `Rendez-vous avec ${clientName}`;

  if (title) {
    composedTitle = `${title}`;
  }

  eventDetails.subject = composedTitle;

  if (meetingPlace === "remote") {
    eventDetails.responseRequested = true;
    eventDetails.allowNewTimeProposals = true;
    eventDetails.isOnlineMeeting = true;
    eventDetails.onlineMeetingProvider = "teamsForBusiness";
  }

  eventDetails.start = {
    dateTime: startDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone,
  };
  eventDetails.end = {
    dateTime: endDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone
  };
  eventDetails.location = {
    displayName: "Microsoft Teams",
  };

  let color = selectedColor;
  if (!color) {
    color = colors[0].id;
  }

  eventDetails.categories = [color];
  eventDetails.attendees = attendees;

  return eventDetails;
}

function composeManagementEventForOutlook({
  title,
  date,
  duration,
  timezone,
  selectedColor,
  attendees,
}) {
  let startDate = date.clone();
  let endDate = date.clone();
  const minutesToAdd = duration;
  const eventDetails = {};

  let composedTitle = "";
  endDate.add(minutesToAdd, "minutes");

  composedTitle = `[Gestion] ${title}`;

  eventDetails.subject = composedTitle;

  eventDetails.start = {
    dateTime: startDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone,
  };
  eventDetails.end = {
    dateTime: endDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone
  };
  eventDetails.location = {
    displayName: "Microsoft Teams",
  };

  let color = selectedColor;
  if (!color) {
    color = colors[0].id;
  }

  eventDetails.categories = [color];
  eventDetails.attendees = attendees;

  return eventDetails;
}

function composeBalancePresentationEventForOutlook({
  title,
  date,
  duration,
  timezone,
  clientName,
  selectedColor,
  attendees,
}) {
  let startDate = date.clone();
  let endDate = date.clone();
  const minutesToAdd = duration;
  const eventDetails = {};

  let composedTitle = "";
  endDate.add(minutesToAdd, "minutes");

  composedTitle = `[Présentation Bilan] ${clientName}`;

  if (title) {
    composedTitle = `${title}`;
  }

  eventDetails.subject = composedTitle;

  eventDetails.start = {
    dateTime: startDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone,
  };
  eventDetails.end = {
    dateTime: endDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone
  };
  eventDetails.location = {
    displayName: "Microsoft Teams",
  };

  let color = selectedColor;
  if (!color) {
    color = colors[0].id;
  }

  eventDetails.categories = [color];
  eventDetails.attendees = attendees;

  return eventDetails;
}

function composeBalanceEcheanceEventForOutlook({
  title,
  date,
  timezone,
  clientName,
  categoryName,
  selectedColor,
  attendees,
}) {
  let startDate = date.clone();
  let endDate = date.clone();
  const eventDetails = {};

  let composedTitle = "";

  composedTitle = `[Échéance Bilan] ${clientName} - ${categoryName}`;

  if (title) {
    composedTitle = `${title}`;
  }

  eventDetails.subject = composedTitle;

  startDate.hour(0);
  startDate.minute(0);
  startDate.second(0);
  startDate.millisecond(0);

  endDate.add(1, "day");
  endDate.hour(0);
  endDate.minute(0);
  endDate.second(0);
  endDate.millisecond(0);

  eventDetails.start = {
    dateTime: startDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone,
  };
  eventDetails.end = {
    dateTime: endDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone
  };
  eventDetails.location = {
    displayName: "Microsoft Teams",
  };

  eventDetails.isReminderOn = true;
  eventDetails.isAllDay = true;

  let color = selectedColor;
  if (!color) {
    color = colors[0].id;
  }

  eventDetails.categories = [color];
  eventDetails.attendees = attendees;
  eventDetails.showAs = 'free';

  return eventDetails;
}

function composeIntermediateSituationBalanceEventForOutlook({
  title,
  date,
  timezone,
  clientName,
  categoryName,
  selectedColor,
  attendees,
}) {
  let startDate = date.clone();
  let endDate = date.clone();
  const eventDetails = {};

  let composedTitle = "";

  composedTitle = `[Situation Intermédiaire] ${clientName} - ${categoryName}`;

  if (title) {
    composedTitle = `${title}`;
  }

  eventDetails.subject = composedTitle;

  startDate.hour(0);
  startDate.minute(0);
  startDate.second(0);
  startDate.millisecond(0);

  endDate.add(1, "day");
  endDate.hour(0);
  endDate.minute(0);
  endDate.second(0);
  endDate.millisecond(0);

  eventDetails.start = {
    dateTime: startDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone,
  };
  eventDetails.end = {
    dateTime: endDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone
  };
  eventDetails.location = {
    displayName: "Microsoft Teams",
  };

  eventDetails.isReminderOn = true;
  eventDetails.isAllDay = true;

  let color = selectedColor;
  if (!color) {
    color = colors[0].id;
  }

  eventDetails.categories = [color];
  eventDetails.attendees = attendees;

  return eventDetails;
}

function composeAbsenceEventForOutlook({
  title,
  date,
  duration,
  timezone,
  selectedColor,
  attendees,
  absenceStatus,
  absenceType
}) {
  let startDate = date.clone();
  let endDate = date.clone();
  const eventDetails = {};

  eventDetails.subject = title;
  if (!title) {
    if (absenceType === 'absence') {
      eventDetails.subject = 'Vacances annuelles';
    }
  }

  startDate.hour(0);
  startDate.minute(0);
  startDate.second(0);
  startDate.millisecond(0);

  if (absenceType === 'partial') {
    startDate.hour(8);
    startDate.minute(0);
    startDate.second(0);
    startDate.millisecond(0);
    endDate = startDate.clone();
    endDate.add(duration, "minutes");
  } else {
    endDate.add(duration, "minutes");
    endDate.hour(0);
    endDate.minute(0);
    endDate.second(0);
    endDate.millisecond(0);
  }

  if (absenceStatus === 'PENDING') {
    eventDetails.showAs = 'free';
  } else if (absenceStatus === 'APPROVED') {
    eventDetails.showAs = 'busy';
  } else if (absenceStatus === 'REJECTED') {
    eventDetails.showAs = 'tentative';
  }

  eventDetails.start = {
    dateTime: startDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone,
  };
  eventDetails.end = {
    dateTime: endDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone
  };
  eventDetails.location = {
    displayName: "Microsoft Teams",
  };

  let color = selectedColor;
  if (!color) {
    color = colors[0].id;
  }

  eventDetails.categories = [color];
  eventDetails.attendees = attendees;

  return eventDetails;
}

function composeNewClientMeetingEventForOutlook({
  title,
  date,
  duration,
  timezone,
  clientName,
  selectedColor,
  attendees,
}) {
  let startDate = date.clone();
  let endDate = date.clone();
  const eventDetails = {};
  let composedTitle = "";

  composedTitle = `Rendez-vous avec ${clientName}`;

  if (title) {
    composedTitle = title;
  }

  eventDetails.subject = composedTitle;

  startDate.hour(9);
  startDate.minute(0);
  startDate.second(0);
  startDate.millisecond(0);

  endDate = startDate.clone();
  endDate.add(30, "minutes");
  endDate.second(0);
  endDate.millisecond(0);

  eventDetails.start = {
    dateTime: startDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone,
  };
  eventDetails.end = {
    dateTime: endDate.format("Y-MM-DDTHH:mm:ss"),
    timeZone: timezone
  };
  eventDetails.location = {
    displayName: "Microsoft Teams",
  };

  let color = selectedColor;
  if (!color) {
    color = colors[0].id;
  }

  eventDetails.categories = [color];
  eventDetails.attendees = attendees;
  eventDetails.isReminderOn = true;

  return eventDetails;
}
